import { Helmet } from "react-helmet-async";
import Banner from '../../components/banner/Banner.tsx'
import Teamcontend from '../../components/team/Teamcontend.tsx'

const Team = () => {
  return (
    <div>
          {/* SEO */}
      <Helmet>
        <title>Notre Équipe - VRN Innovation</title>
        <meta
          name="description"
          content="Découvrez l’équipe de VRN Innovation à Douala : des experts en développement web, mobile, réseaux, sécurité, domotique, Starlink, marketing digital et consulting IT, dédiés à vos projets."
        />
        <meta
          name="keywords"
          content="Équipe VRN Innovation, experts IT Douala, développeurs web Cameroun, ingénieurs réseaux, consultants IT, domotique, Starlink"
        />
        <link rel="canonical" href="https://www.vrn-innovation.com/team" />
      </Helmet>
      <Banner
        title="Nos membres"
        breadcrumbs={[
          { label: "Accueil", link: "/" },
          { label: "Team" },
        ]}
      />
      <Teamcontend />
    </div>
  )
}

export default Team
